<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import type { LinkComponentIconProps } from './types';

  type $$Props = LinkComponentIconProps;
  export let nofollow: $$Props['nofollow'] = undefined;
  export let target: $$Props['target'] = undefined;
  export let text: $$Props['text'];
  export let url: $$Props['url'];
  export let icon: $$Props['icon'] = undefined;
  export let modal: $$Props['modal'] = undefined;

  const dispatch = createEventDispatcher();

  function handleOnClick(event: Event) {
    if (modal) {
      event.preventDefault();
      dispatch('open-modal');
    }
  }
</script>

<a class="LinkComponent--icon" href={url} {target} rel={nofollow} on:click={handleOnClick}>
  <div class="iconAndTextContainer">
    <div class="icon">
      <!-- eslint-disable-next-line svelte/no-at-html-tags - icon is imported from public-web-icons -->
      {@html icon}
    </div>
    <div class="iconText">
      {text}
    </div>
  </div>
</a>

<style lang="scss">
  @use '@squareup/public-web-design-system/dist/styles/xms-fe/mixins/_grid.scss' as grid;
  .LinkComponent--icon {
    display: inline-block;
    vertical-align: middle;
    color: var(--color-blue);
    font-weight: var(--font-weight-medium);
    text-decoration: none;
  }

  .iconAndTextContainer {
    @include grid.flex;
    @include grid.space(10);
    @include grid.valign('middle');
  }

  .icon {
    color: transparent;
    flex-shrink: 0;

    :global(svg) {
      fill: var(--color-gray-90);
    }
  }
</style>
